// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Perfil_MeuResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET e POST /perfil/meu — os dados pessoais de quem está logado. */
import type { Perfil_DadosRow } from './Perfil_DadosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Perfil_MeuResponseDados {
dados: Perfil_DadosRow
email: string
faltando: string[]
}

export type Perfil_MeuResponse = ApiResponse<Perfil_MeuResponseDados>;

registerResponseContract('Perfil_MeuResponse', {
  dados: {
    type: 'object',
    required: true,
    fields: {
      nome_completo:   { type: 'string',  required: false },
      cpf:             { type: 'string',  required: false },
      rg:              { type: 'string',  required: false },
      data_nascimento: { type: 'string',  required: false },
      estado_civil:    { type: 'string',  required: false },
      profissao:       { type: 'string',  required: false },
      telefone:        { type: 'string',  required: false },
      cep:             { type: 'string',  required: false },
      endereco:        { type: 'string',  required: false },
      numero:          { type: 'string',  required: false },
      complemento:     { type: 'string',  required: false },
      bairro:          { type: 'string',  required: false },
      cidade:          { type: 'string',  required: false },
      uf:              { type: 'string',  required: false },
    },
  },
  email:    { type: 'string',  required: true },
  faltando: { type: 'array',   required: true },
})
